import styled from '@emotion/styled';

export const ActionToolBarWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
`;
